<section class="pt-32 lg:pt-56 lg:pb-28">
  <app-community />
</section>
